import { Button } from 'components/Button/Button';
import type { ListingType } from 'types/ListingType';
import { showModal } from 'zustand-stores/modalStore';

type Props = {
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  orgId: string | null;
};

export function ShareMenuItem({
  listingId,
  listingType,
  listingUrl,
  orgId,
}: Props) {
  if (listingType !== 'ORG' && !orgId) {
    return null;
  }

  return (
    <Button
      data-qa-id="share-button"
      onClick={() => {
        showModal('SHARE_LISTING', {
          listingId,
          listingType,
          listingUrl,
        });
      }}
      variant="link-grey"
      iconPosition="left"
      icon={{ type: 'normalized', name: 'share' }}
      size="small"
      type="button"
    >
      {getText('Share')}
    </Button>
  );
}
